import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import { styled } from 'styled-components'

import { Typography } from '../../Typography/Typography'

export const StyledFaq = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.radius['Radius XL']}px;
  background: ${({ theme }) => theme.colors['N Surface/Primary']};
`

export const StyledFaqHeader = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0.75rem;
  border: none;
  background: transparent;
  cursor: pointer;
  gap: 0.5rem;
  text-align: left;
`

export const StyledFaqQuestion = styled(Typography)`
  min-width: 0;
  flex: 1;
  padding: 0 0.25rem;
  user-select: none;
`

export const StyledFaqToggle = styled.span<{ $isOpen: boolean }>`
  display: flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 2rem;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.radius['Radius FULL']}px;
  background: ${({ theme }) => theme.colors['N Surface/Secondary']};
  color: ${({ theme }) => theme.colors['N Content/Secondary']};

  ${StyledIcon} {
    width: 1rem;
    height: 1rem;
    color: inherit;
    transform: rotate(${({ $isOpen }) => ($isOpen ? '270deg' : '90deg')});
    transition: transform 0.3s ease;
  }
`

export const StyledFaqAnswer = styled.div<{ $isOpen: boolean }>`
  display: grid;
  grid-template-rows: ${({ $isOpen }) => ($isOpen ? '1fr' : '0fr')};
  transition: grid-template-rows 0.3s ease;
`

export const StyledFaqAnswerInner = styled.div`
  overflow: hidden;
  min-height: 0;
`

export const StyledFaqAnswerText = styled(Typography)`
  padding: 0 1rem 1rem;
`
